type ParticipatingDistricts = {
  id: string;
  riDistrictId: number;
};

export const getParticipatingDistrictsRow = (
  districts: ParticipatingDistricts[],
  districtID: string
): string => {
  return districts
    .map(({ id, riDistrictId }) =>
      id === districtID ? `${riDistrictId}*` : `${riDistrictId}`
    )
    .join(', ');
};
